import { Button } from "@/components/elements/Button";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Table } from "@/components/elements/Table";
import { TMasterResidenceStatusCreateForm, TResidencePeriodForm } from "@/features/master-data/types/masterDataResidencePeriodForm";
import { useFormTable } from "@/hooks/useFormTable";
import { Box, styled } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useFormContext, useWatch } from "react-hook-form";

export const CreateResidenceStatusFormTable = () => {
  const { control, setValue, watch } = useFormContext<TMasterResidenceStatusCreateForm>();

  const residenceStatusRenewVisaCsvCodeWatchField = useWatch({
    control,
    name: `residenceStatusRenewVisaCsvCode`,
  });

  const formColumns: MRT_ColumnDef<TResidencePeriodForm>[] = [
    {
      header: "在留期間",
      Cell: ({ row }) => {
        return (
          <FormField control={control} name={`residencePeriods.${row.index}.residencePeriod`}>
            <Input />
          </FormField>
        );
      },
    },
    {
      header: "在留期間の在留申請CSVコード",
      Cell: ({ row }) => {
        return (
          <FormField control={control} name={`residencePeriods.${row.index}.residencePeriodRenewVisaCsvCode`}>
            <Input />
          </FormField>
        );
      },
    },
    {
      header: "希望する在留期間",
      Cell: ({ row }) => {
        return (
          <FormField control={control} name={`residencePeriods.${row.index}.desiredResidencePeriod`}>
            <Input />
          </FormField>
        );
      },
    },
    {
      header: "希望する在留期間の在留申請CSVコード",
      Cell: ({ row }) => {
        const residencePeriodRenewVisaCsvCodeWatchField = watch(`residencePeriods.${row.index}.residencePeriodRenewVisaCsvCode`);

        return (
          <>
            <FormField sx={{ width: 250 }} control={control} name={`residencePeriods.${row.index}.desiredResidencePeriodRenewVisaCsvCode`}>
              <Input />
            </FormField>

            <Button
              sx={{ ml: 1 }}
              size="sm"
              variant="outline"
              onClick={() =>
                setValue(
                  `residencePeriods.${row.index}.desiredResidencePeriodRenewVisaCsvCode`,
                  `${residenceStatusRenewVisaCsvCodeWatchField || ""}${residencePeriodRenewVisaCsvCodeWatchField || ""}`,
                )
              }
            >
              自動入力
            </Button>
          </>
        );
      },
      muiTableBodyCellProps: {
        sx: { minWidth: "unset", maxWidth: "320px" },
      },
      muiTableHeadCellProps: {
        sx: { minWidth: "unset", maxWidth: "320px" },
      },
    },
  ];

  const { table } = useFormTable({
    columns: formColumns,
    control,
    name: "residencePeriods",
    initFieldData: {
      desiredResidencePeriod: "",
      desiredResidencePeriodRenewVisaCsvCode: "",
      residencePeriod: "",
      residencePeriodRenewVisaCsvCode: "",
    },
    primaryKey: "id",
  });

  return (
    <TableWrapper>
      <Table table={table} maxHeight={400} />
    </TableWrapper>
  );
};

const TableWrapper = styled(Box)`
  .MuiTableHead-root {
    th {
      font-size: 14px;
    }
  }
`;
